import { track } from "../units/tracking";
import { queryClient } from "../units/react-query-client";
import { getApiUrl } from "../utils/get-api-url";
import { CREATE_QUOTE_PAGE } from "../constants";

interface SwitchProductProps {
  quoteId: string;
  targetProductId: string;
}

export const switchProduct = async ({
  quoteId,
  targetProductId
}: SwitchProductProps) => {
  const apiUrl = getApiUrl("quotesapi");
  const endpoint = `${apiUrl}/quotes/${quoteId}`;

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
  };

  const bodyParams = new URLSearchParams({
    targetProductId,
    sourceQuoteId: quoteId
  });

  return fetch(endpoint, {
    method: "PATCH",
    headers,
    credentials: "include",
    body: bodyParams.toString()
  })
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    })
    .then(res => {
      const { carrier, inputs, productType } = res;
      const isFastPremium =
        inputs.QuoteOriginationSystem ===
        CREATE_QUOTE_PAGE.QUOTE_ORIGINATION_SYSTEM.AP_FP;

      // PATCH currently doesn't run client-side rulesets (PPQ-8115)
      // invalidate the queries so that the next GET will update the qutoe
      queryClient.removeQueries(["quotes.getQuote", { id: quoteId }], res);

      // Product changed so invalidate the layout call for this quote
      queryClient.removeQueries(["quotes.getContext", { id: quoteId }]);

      track("Quote - Quote Copied", {
        quoteId,
        carrier,
        productType,
        isFastPremium
      });

      return res;
    });
};
